export enum TypeNotify {
    assegnazioneNonCognitivo = 'ASSEGNAZIONE_QUESTIONARIO_NON_COGNITIVO',
    assegnazioneCognitivo = 'ASSEGNAZIONE_QUESTIONARIO_COGNITIVO',
    assegnazioneModulo = 'ASSEGNAZIONE_MODULO'
}